export enum SiteLocation {
  OnSite = 'Onsite',
  OffSite = 'Offsite',
}
